export const getVerticalFooterData = (vertical) => [];
export const setVerticalFooterData = (vertical, sync = false) => { };
